angular.module('siteSettings', [
  'common',
  'backend'
]);
